import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../LanguageContext';
const images = ['https://cdn.magicpatterns.com/uploads/7wxNgrxFtt1mDDNqWCWQg8/skin3.png', 'https://cdn.magicpatterns.com/uploads/qZAtN8rYGXrQo9d5zN9Jqz/skin4.png', 'https://cdn.magicpatterns.com/uploads/kTytfZYE1LrbER7EnMsgEp/skin22.png', 'https://cdn.magicpatterns.com/uploads/mzP22sG2ZiBFCe2pC6FRxY/skin1.png'];
// Duplicate the array to create a seamless loop
const duplicatedImages = [...images, ...images, ...images];
export const TopCarousel = () => {
  const {
    language
  } = useLanguage();
  return <section className="py-12 bg-brand-ivory overflow-hidden relative border-b border-brand-gold/10" data-id="element-416">
      <div className="container mx-auto px-6 mb-8 text-center" data-id="element-417">
        <h2 className="text-2xl md:text-3xl font-serif text-brand-charcoal mb-3" data-id="element-418">
          {language === 'es' ? 'Resultados Reales' : 'Real Results'}
        </h2>
        <div className="h-px w-16 bg-brand-gold mx-auto" data-id="element-419"></div>
      </div>

      {/* Gradient masks for smooth fade on edges */}
      <div className="absolute left-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-r from-brand-ivory to-transparent z-10 pointer-events-none" data-id="element-420"></div>
      <div className="absolute right-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-l from-brand-ivory to-transparent z-10 pointer-events-none" data-id="element-421"></div>

      <div className="flex w-full" data-id="element-422">
        <motion.div className="flex gap-4 md:gap-6 px-4 py-4" animate={{
        x: ['0%', '-33.333333%']
      }} transition={{
        ease: 'linear',
        duration: 20,
        repeat: Infinity
      }} data-id="element-423">
          {duplicatedImages.map((src, index) => <div key={index} className="relative w-64 h-80 md:w-72 md:h-96 flex-shrink-0 bg-brand-cream p-2.5 md:p-3 rounded-2xl shadow-xl border border-brand-gold/20 group" data-id="element-424">
              <div className="relative w-full h-full rounded-xl overflow-hidden border border-brand-gold/30" data-id="element-425">
                <img src={src} alt={language === 'es' ? `Tratamiento Skin Glow ${index + 1}` : `Skin Glow Treatment ${index + 1}`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-426" />
                <div className="absolute inset-0 bg-brand-charcoal/10 group-hover:bg-transparent transition-colors duration-500" data-id="element-427"></div>
              </div>
            </div>)}
        </motion.div>
      </div>
    </section>;
};